/** ****************************************************************************
		███╗   ██╗███████╗██████╗  █████╗  ██████╗
		████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗
		██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║
		██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║
		██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝
		╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝

@description Template pour les pages.

@author Victor Audetat <audetat.v@gmail.com>

@copyright © 2020  NEDAO Association (info@nedao.ch)
@see {@link https://association.nedao.ch}

@license
	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published
	by the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.
*******************************************************************************/

import React, {useEffect, useState} from "react";
import Nav from "../nav/Nav";
import Footer from "../footer/Footer";
import background from "url:./../../media/background.svg";

const Template = (props) => {

	const [scrollPos, setScrollPos] = useState();

	useEffect(() => {
		window.addEventListener("scroll", scrollEffect, { passive: true });
		return () => {
			window.removeEventListener("scroll", scrollEffect);
		};
	});

	const scrollEffect = () => {
		setScrollPos(window.pageYOffset);
	};

	const style = {
		backgroundImage: `url(${background})`,
		backgroundSize: "100%",
		backgroundRepeat: "no-repeat",
		backgroundPositionY: scrollPos > 0 ? `${(scrollPos / 2) + 400}px` : "400px",
	};

	return (
		<div className="global__layout" style={style}>
			<Nav bigLogo={props.bigLogo}/>
			{props.children}
			<Footer />
		</div>
	);
};

export default Template;